import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";
import { FilterBase } from "@models/base/filterBase.model";

export class PlantillaEscritoFilter extends FilterBase {

  public id: number | null = null;
  public idsTipoEscrito: (number | null)[] = [];
  public creadoPor: number | null = null;
  public titulo: string | null = null;
  public fechaAltaDesde: Date | null = null;
  public fechaAltaHasta: Date | null = null;
  public fechaModificacionDesde: Date | null = null;
  public fechaModificacionHasta: Date | null = null;
}
